import baseApi from "./RootBaseApi";
import {
  PlatformSetting,
  PlatformSettingsResponse,
  PlatformSettingsParams,
} from "@/types/platform-settings.types";

export const PlatformSettingsService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlatformSettings: builder.query<
      PlatformSettingsResponse,
      PlatformSettingsParams
    >({
      query: (params) => ({
        url: "/platform_settings",
        method: "GET",
        params,
      }),
      providesTags: ["PlatformSettings"],
    }),
    getPlatformSettingById: builder.query<PlatformSetting, string>({
      query: (id) => ({
        url: `/platform_settings/${id}`,
        method: "GET",
      }),
      transformResponse: (response: { data: PlatformSetting }) => response.data,
      providesTags: ["PlatformSettings"],
    }),
    updatePlatformSetting: builder.mutation<
      PlatformSetting,
      { id: string; data: FormData | { key: string; value: string | boolean } }
    >({
      query: ({ id, data }) => ({
        url: `/platform_settings/${id}`,
        method: "PATCH",
        data,
      }),
      invalidatesTags: ["PlatformSettings"],
    }),
  }),
});

export const {
  useGetPlatformSettingsQuery,
  useGetPlatformSettingByIdQuery,
  useUpdatePlatformSettingMutation,
} = PlatformSettingsService;
